import React, { forwardRef } from "react";
import styles from "./horizontal-form-input-field.module.css";

const HorizontalFormInputField = forwardRef((props, ref) => {
  const {
    value,
    onChange,
    title,
    hint,
    inputType = "text",
    inputName,
    inputId,
    pattern,
    min,
    max,
    className = "",
    inputClassName = "",
    requireFocus,
    showShadow = true,
    ...restprops
  } = props;

  return (
    <div className={`${styles.formContainer} ` + className}>
      <label htmlFor={inputId} className={styles.label}>
        {title}
      </label>
      <input
        ref={ref}
        name={inputName}
        id={inputId}
        type={inputType}
        value={value}
        pattern={pattern}
        className={`${styles.input}  ${
          showShadow && "boxShadow-md "
        } ${inputClassName}`}
        onChange={onChange}
        placeholder={hint}
        min={min}
        max={max}
        {...restprops}
      />
    </div>
  );
});

export default HorizontalFormInputField;
